<template>
  <div class="w-100">
    <div class="container-fluid px-2">
      <div class="row align-items-center mb-2 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start mb-3"
          >
            <span class="carousel_title_new">{{ title }}</span>
            <div
              class="d-flex flex-row align-items-center ml-3 view-all-wrapper"
              v-if="showMore"
              @click="viewMore()"
            >
              <span class="see-more-text cursor-pointer">View All</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row mx-0 latest-tv-rails-content"
        id="landscapePodcastCarousel"
      >
        <div class="owl-carousel owl-theme" :id="titleCarousel">
          <div
            class="item"
            v-for="item_vod in rails"
            :key="titleCarousel + ' - ' + item_vod.id"
          >
            <PodcastCard
              :image="imgFiltering(item_vod)"
              :title="formatString(item_vod.longTitle)"
              :description="item_vod.data.description"
              :link="checkLink(item_vod)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import noimage from "../../assets/podcast-no-image.png";
import PodcastCard from "../cards/v2/podcastCard.vue";
export default {
  name: "rails-landscape",
  props: ["title", "datasource", "cat", "cat_id", "program_id"], //kalau nk rails based on program id, and not category id, guna program_id
  data: function() {
    return {
      titleCarousel: this.title.replace(/\s/g, "").toLowerCase(),
      noimage: noimage,
      showMore: false,
      contenttype: this.datasource,
      rails: [],
    };
  },
  components: { PodcastCard },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    viewMore() {
      var itemToPass = this.rails;
      var contenttype = this.contenttype;

      if (this.cat_id) {
        this.$router.replace(
          "/viewall?cat=" +
            this.cat +
            "&contenttype=" +
            contenttype +
            "&cat_id=" +
            this.cat_id
        );
      } else {
        this.$router.replace("/podcastplayer?id=" + this.program_id);
      }
    },
    goTo(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema;
      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (item.idSchema == "204") {
        //pod episode
        // get main podcast id id=382&eps_id=385
        var podcast_id = item.data.podcast.id;
        link = "/podcastplayer?id=" + podcast_id + "&eps_id=" + item.id;
      }

      return link;
    },
    checkIndexForMore() {
      var listlength = this.rails;
      if (listlength.length > 5) {
        this.showMore = true;
      }
    },
    async initializeContentForStart() {
      var vm = this;
      const url = vm.cat_id
        ? `https://rtb.glueapi.io/v1/content?fieldPath=category&fieldValue=${
            vm.cat_id
          }&limit=10&idSchemas=203`
        : `https://cdn-rtb.glueapi.io/v1/content/${
            vm.program_id
          }?format=json&limit=10`;

      if (vm.cat_id) {
        let response = await axios.get(url, {
          responseType: "json",
        });

        vm.rails = response.data.data;

        var target = document.getElementById(vm.titleCarousel);
        if (vm.rails) {
          this.checkIndexForMore();
          Vue.nextTick(
            function() {
              vm.installOwlCarousel(target);
            }.bind(vm)
          );
        }
      } else {
        let response_program = await axios.get(url, {
          responseType: "json",
        });

        let episodes = response_program.data.data.data["podcast-episode"];
        let episode_list = [];

        episodes.forEach(function(items) {
          const myUrl = `https://cdn-rtb.glueapi.io/v1/content/${
            items.id
          }?format=json`;
          episode_list.push(axios.get(myUrl));
        });

        Promise.all(episode_list).then(function(results) {
          results.forEach(function(response, index) {
            const res = response.data.data;
            if (res) {
              vm.rails.push(response.data.data);
            }

            if (index == results.length - 1) {
              vm.rails.sort(function(a, b) {
                return b.id - a.id;
              });
            }
          });
        });

        if (vm.rails) {
          setTimeout(
            function() {
              var target = document.getElementById(vm.titleCarousel);
              this.checkIndexForMore();
              Vue.nextTick(
                function() {
                  vm.installOwlCarousel(target);
                }.bind(vm)
              );
            }.bind(this),
            700
          );
        }
      }
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: true,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-lg"></span>',
          '<span class="fa fa-chevron-right fa-lg"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            loop: false,
            margin: 8,
            stagePadding: 4,
          },
          768: {
            items: 3,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
          1280: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
        },
      });
    },
  },
  beforeMount() {
    setTimeout(
      function() {
        this.initializeContentForStart();
      }.bind(this),
      2000
    );
  },
};
</script>

<!-- new -->
<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#landscapePodcastCarousel .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #landscapePodcastCarousel .owl-theme:hover {
    z-index: 111;
  }

  #landscapePodcastCarousel .owl-theme {
    height: auto;
  }
  #landscapePodcastCarousel .owl-item {
    z-index: 1;
  }
  #landscapePodcastCarousel .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #landscapePodcastCarousel .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #landscapePodcastCarousel .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #landscapePodcastCarousel .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #landscapePodcastCarousel .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #landscapePodcastCarousel .owl-next span,
  #landscapePodcastCarousel .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
